import React from 'react';
import PageNavigationController from 'PageNavigation/PageNavigationController';
import { dicontainer } from "DIContainer";
import Page from "PageNavigation/Page";
import MenuItem from "MainLayout/MenuItem";
import IEmptyProps from "EmptyProps";
import classNames from 'classnames';
import Anchor from "PageNavigation/Anchor";
import { HTMLElementProperty, HTMLElementPropertyUnit, SimpleEventArgs } from 'ts-common-utils';

interface ITitleBarState {
    menuExpanded: boolean,
    activePage?: Page
    activeAnchor?: Anchor,
    scrolled: boolean;
}

export default class TitleBar extends React.Component<IEmptyProps, ITitleBarState> {
    private _desktopTitleBar!: HTMLElement;
    private _mobileTitleBar!: HTMLElement;
    private _pageNavigationController: PageNavigationController = dicontainer.get(PageNavigationController);

    private _menuItems = [
        { title: "Accueil", pageName: "accueil", anchorName: "accueil", highlight: true, mobileOnly: false },
        { title: "Événements", pageName: "accueil", anchorName: "evenements", highlight: true, mobileOnly: false },
        { title: "Services", pageName: "accueil", anchorName: "services", highlight: true, mobileOnly: false },
        { title: "Tarifs", pageName: "accueil", anchorName: "tarifs", highlight: true, mobileOnly: false },
        { title: "Nous joindre", pageName: "accueil", anchorName: "nous-joindre", highlight: true, mobileOnly: false }
    ];

    public constructor(props: IEmptyProps) {
        super(props);
        this.state = {
            activePage: this._pageNavigationController.activePage,
            activeAnchor: this._pageNavigationController.activeAnchor,
            menuExpanded: false,
            scrolled: false
        };
        this.handleAnchorChange = this.handleAnchorChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
        this.handleLogoClick = this.handleLogoClick.bind(this);
        this.handleMenuToggleClick = this.handleMenuToggleClick.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleTitleBarClick = this.handleTitleBarClick.bind(this);
        this._pageNavigationController.onAnchorChange.addHandler(this.handleAnchorChange);
        this._pageNavigationController.onPageChange.addHandler(this.handlePageChange);
        this._pageNavigationController.onScroll.addHandler(this.handleScroll);
    }

    private handleMenuToggleClick() {
        this.setState({ menuExpanded: !this.state.menuExpanded });
    }

    private handleMenuItemClick(sender: MenuItem) {
        this._pageNavigationController.switch(sender.props.pageName, sender.props.anchorName);
        this.setState({ menuExpanded: false });
    }

    private handleAnchorChange(sender: any, e: SimpleEventArgs<Anchor | undefined>) {
        this.setState({ activeAnchor: e.value });
    }

    private handlePageChange(sender: any, e: SimpleEventArgs<Page>) {
        this.setState({ activePage: e.value });
    }

    private handleLogoClick() {
        this._pageNavigationController.switch("accueil", undefined, false);
    }

    public handleScroll(sender: object, e: SimpleEventArgs<Event>) {
        let element = e.value.target as HTMLDivElement;
        this._desktopTitleBar.setNumericValue(HTMLElementProperty.Top, element.scrollTop, HTMLElementPropertyUnit.Pixel);
        this._mobileTitleBar.setNumericValue(HTMLElementProperty.Top, element.scrollTop, HTMLElementPropertyUnit.Pixel);
        this.setState({ scrolled: element.scrollTop >= 60 });
    }

    private handleTitleBarClick(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
        if (this.state.menuExpanded) {
            this.setState({ menuExpanded: false });
        }
    }

    public render() {
        return ([
                <div key="title-bar" ref={c => this._desktopTitleBar = c!} className={classNames("title-bar desktop", {"scrolled": this.state.scrolled}, this.state.activePage?.name)}>
                    <div className="left" onClick={this.handleLogoClick}>
                        <img className="logo" src="img/logo.svg" />
                    </div>
                    <div className="right">
                        <ul>
                            {this._menuItems.filter(m => !m.mobileOnly).map(menuItem =>
                                <MenuItem key={menuItem.pageName + menuItem.anchorName} text={menuItem.title} active={this.state.activePage?.name == menuItem.pageName && this.state.activeAnchor?.name == menuItem.anchorName && menuItem.highlight}
                                    pageName={menuItem.pageName} anchorName={menuItem.anchorName} onMenuItemClick={this.handleMenuItemClick} />)
                            }
                        </ul>
                    </div>
                </div>,
                <div key="mobile" ref={c => this._mobileTitleBar = c!} className={classNames("title-bar mobile", {"expanded": this.state.menuExpanded, "scrolled": this.state.scrolled})} onClick={this.handleTitleBarClick}>
                    <div className="top">
                        <div className="left">
                            <div className="menu-toggle" onClick={this.handleMenuToggleClick}>
                                <div className="line"></div>
                                <div className="line"></div>
                                <div className="line"></div>
                            </div>
                            <img className="logo" src="img/logo.svg" onClick={this.handleLogoClick} />
                        </div>
                    </div>
                    <ul className={classNames({"expanded": this.state.menuExpanded, "collapsed": !this.state.menuExpanded})} id="menu">
                        {this._menuItems.map(menuItem =>
                            <MenuItem key={menuItem.pageName + menuItem.anchorName} text={menuItem.title} active={this.state.activePage?.name == menuItem.pageName && this.state.activeAnchor?.name == menuItem.anchorName && menuItem.highlight}
                                pageName={menuItem.pageName} anchorName={menuItem.anchorName} onMenuItemClick={this.handleMenuItemClick} />)
                        }
                    </ul>
                </div>
            ]
        );
    }
}